import * as React from 'react'
import CancelMeetingModal from '../../CancelMeetingModal'
import { useCoachDashboard } from '../../CoachDashboardProvider'

export function ActionsCell({ row }) {
  const request = row.original
  const [modalOpen, setModalOpen] = React.useState(false)
  const { handleCancelMeeting } = useCoachDashboard()

  const handleCancelClick = () => {
    setModalOpen(true)
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  const handleCancelConfirm = (meeting, message) => {
    handleCancelMeeting(meeting.service_request_id, message)
    setModalOpen(false)
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <a href={request.join_url} target="_blank" rel="noopener noreferrer">
        Join Meeting
      </a>
      <button
        type="button"
        className="text-red-700 hover:text-red-500"
        onClick={handleCancelClick}
      >
        Cancel &amp; Message Candidate
      </button>
      <CancelMeetingModal
        open={modalOpen}
        meeting={request}
        onClose={handleModalClose}
        onConfirm={handleCancelConfirm}
      />
    </div>
  )
}
